module.exports = __webpack_public_path__ + "static/media/ios-ice-cream.e1855538.svg";